











import { defineComponent } from '@vue/composition-api';
export default defineComponent({
	props: {
		text: {
			type: String,
			required: true,
		},
		linkTo: {
			type: String,
			required: false,
			default: '',
		},
		handleClick: {
			type: Function,
			required: false,
			default: () => {
				/* noop */
			},
		},
	},
});
